import { omdApi } from 'bus/api';
import {
    EmployeeSalaryAdjustmentsDetail,
    EmployeeSalaryAdjustmentsDetailRequest,
    EmployeeSalaryAdjustmentsInfoItem,
    EmployeeSalaryAdjustmentsItem,
} from './types';
import { PayloadRequest } from 'types/requestTypes';

const employeeSalaryAdjustmentsApi = omdApi.injectEndpoints({
    endpoints: (builder) => ({
        getEmployeeSalaryAdjustments: builder.query<EmployeeSalaryAdjustmentsItem, PayloadRequest>({
            query: (data) => ({
                url: `/v1/employeeSalaryAdjustments/${data.id}`,
            }),
        }),
        createEmployeeSalaryAdjustments: builder.mutation<void, EmployeeSalaryAdjustmentsItem>({
            query: (data) => ({
                url: `/v1/employeeSalaryAdjustments/`,
                method: 'POST',
                body: data,
            }),
        }),
        editEmployeeSalaryAdjustments: builder.mutation<void, EmployeeSalaryAdjustmentsItem>({
            query: (data) => ({
                url: `/v1/employeeSalaryAdjustments/${data.id}`,
                method: 'PUT',
                body: data,
            }),
        }),
        deleteEmployeeSalaryAdjustments: builder.mutation<void, PayloadRequest>({
            query: (data) => ({
                url: `/v1/employeeSalaryAdjustments/${data.id}`,
                method: 'DELETE',
            }),
        }),
        getEmployeeSalaryAdjustmentsInfo: builder.query<EmployeeSalaryAdjustmentsInfoItem, PayloadRequest>({
            query: (data) => ({
                url: `/v1/employeeSalaryAdjustments/${data.id}/info`,
            }),
        }),
        // details
        getEmployeeSalaryAdjustmentsDetailList: builder.query<EmployeeSalaryAdjustmentsDetail[], PayloadRequest>({
            query: (data) => ({
                url: `/v1/employeeSalaryAdjustments/${data.id}/details`,
            }),
        }),
        getEmployeeSalaryAdjustmentsDetailOne: builder.query<EmployeeSalaryAdjustmentsDetail, PayloadRequest>({
            query: (data) => ({
                url: `/v1/employeeSalaryAdjustments/details/${data.id}`,
            }),
        }),
        createEmployeeSalaryAdjustmentsDetail: builder.mutation<void, EmployeeSalaryAdjustmentsDetailRequest>({
            query: (data) => ({
                url: `/v1/employeeSalaryAdjustments/${data.adjustmentId}/details`,
                method: 'POST',
                body: data,
            }),
        }),
        editEmployeeSalaryAdjustmentsDetail: builder.mutation<void, EmployeeSalaryAdjustmentsDetailRequest>({
            query: (data) => ({
                url: `/v1/employeeSalaryAdjustments/details/${data.id}`,
                method: 'PUT',
                body: data,
            }),
        }),
        deleteEmployeeSalaryAdjustmentsDetail: builder.mutation<void, PayloadRequest>({
            query: (data) => ({
                url: `/v1/employeeSalaryAdjustments/details/${data.id}`,
                method: 'DELETE',
            }),
        }),
    }),
});

export const {
    useGetEmployeeSalaryAdjustmentsQuery,
    useLazyGetEmployeeSalaryAdjustmentsQuery,
    useCreateEmployeeSalaryAdjustmentsMutation,
    useEditEmployeeSalaryAdjustmentsMutation,
    useDeleteEmployeeSalaryAdjustmentsMutation,
    useGetEmployeeSalaryAdjustmentsInfoQuery,
    useLazyGetEmployeeSalaryAdjustmentsInfoQuery,
    useGetEmployeeSalaryAdjustmentsDetailListQuery,
    useLazyGetEmployeeSalaryAdjustmentsDetailListQuery,
    useGetEmployeeSalaryAdjustmentsDetailOneQuery,
    useLazyGetEmployeeSalaryAdjustmentsDetailOneQuery,
    useCreateEmployeeSalaryAdjustmentsDetailMutation,
    useEditEmployeeSalaryAdjustmentsDetailMutation,
    useDeleteEmployeeSalaryAdjustmentsDetailMutation,
} = employeeSalaryAdjustmentsApi;


